import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { LinkedIn as LinkedInIcon } from '@mui/icons-material';

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <AppBar position='sticky' elevation={0} component='footer' color='primary'>
            <Toolbar sx={{ justifyContent: 'center', gap: 2 }}>
                <Typography variant='caption'>©{year} ColbrenSolutions</Typography>
                <Box
                    component='a'
                    href='https://www.linkedin.com/in/colbrensolutions-jeffmay/'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{ color: 'white', display: 'flex', alignItems: 'center' }}
                    aria-label='LinkedIn'
                >
                    <LinkedInIcon fontSize='small' />
                </Box>
            </Toolbar>
        </AppBar>
    );
};
